import { useLanguage } from "@/LanguageContext";
import { ChapterLabel, MaskedLine, Reveal } from "@/components/Reveal";

const Values = () => {
  const { t } = useLanguage();
  const v = t.values;

  return (
    <section id="metodo" className="border-b border-noom-line bg-white" data-testid="section-values">
      <div className="mx-auto max-w-[1600px] px-6 py-24 lg:px-16 lg:py-36">
        <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
          <div>
            <ChapterLabel testId="values-label">{v.label}</ChapterLabel>
            <h2 className="mt-6 font-display text-4xl font-semibold tracking-[-0.02em] text-noom-ink sm:text-5xl">
              <MaskedLine inView>{v.heading}</MaskedLine>
            </h2>
          </div>
          <Reveal delay={0.15}>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-noom-faint">(04)</p>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-px border border-noom-line bg-noom-line md:grid-cols-2" data-testid="grid-studio-values">
          {v.items.map((item, i) => (
            <Reveal key={i} delay={i * 0.08} className="bg-white">
              <div
                data-testid={`value-card-${i + 1}`}
                className="group h-full p-8 transition-colors duration-500 lg:p-12 hover:bg-[#F9F9F9]"
              >
                <p className="font-display text-5xl font-semibold tracking-tight text-noom-line transition-colors duration-500 group-hover:text-noom-lilac">
                  {String(i + 1).padStart(2, "0")}
                </p>
                <h3 className="mt-8 font-display text-xl font-semibold tracking-tight text-noom-ink sm:text-2xl">
                  {item.title}
                </h3>
                <p className="mt-4 max-w-md text-sm leading-relaxed text-noom-muted sm:text-base">{item.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Values;
